<script lang="ts">
const { $i18n } = useNuxtApp();

export default {
  name: "LangSwitcher",
  emits: ["changeLocale"],
};
</script>

<template>
  <v-select
    class="pa-0 lang-switcher"
    variant="underlined"
    density="compact"
    :items="$i18n.locales"
    :modelValue="$i18n.locale"
    @update:modelValue="$emit('changeLocale', $event)"
    :placeholder="$i18n.locale"
    :item-title="(item) => item.code"
    :hide-details="true"
  />
</template>

<style scoped lang="scss">
.lang-switcher {
  width: 45px;

  :deep(.v-field) {
    .v-field__input {
      padding-top: 0;
    }

    .v-field__append-inner {
      padding-top: 0;
    }
  }
}
</style>
